import { render } from "./AdminReleasesView.vue?vue&type=template&id=36a794bb&scoped=true"
import script from "./AdminReleasesView.vue?vue&type=script&lang=js"
export * from "./AdminReleasesView.vue?vue&type=script&lang=js"

import "./AdminReleasesView.vue?vue&type=style&index=0&id=36a794bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a794bb"]])

export default __exports__